import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle
} from "./helper";

export const RequirementsAwaitingReviewPayee: NotificationAlertOverride = (
  notification,
  history
) => {
  return {
    theme: "info",
    icon: "time",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsAwaitingReviewPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsAwaitingReviewPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
